import { render, staticRenderFns } from "./ButtonWrapper.vue?vue&type=template&id=08477640&scoped=true&lang=pug"
import script from "./ButtonWrapper.vue?vue&type=script&lang=ts"
export * from "./ButtonWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ButtonWrapper.vue?vue&type=style&index=0&id=08477640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08477640",
  null
  
)

export default component.exports